import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import styled from "styled-components";

const FileViewerModal = ({ open, onClose, fileUrl }) => {
  if (!fileUrl) return null;

  const StyledDocViewer = styled(DocViewer)`
    .react-doc-viewer__container {
      background-color: #f8f9fa;
      padding: 10px;
    }

    .react-doc-viewer__iframe {
      height: 90vh !important;
      min-height: 1000px;
      border: none;
    }
  `;

  const fileExtension = fileUrl.split(".").pop().toLowerCase();
  const supportedDocs = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx"];
  const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension);
  const isVideo = ["mp4", "webm", "ogg"].includes(fileExtension);

  // Map file extensions to MIME types for DocViewer
  const fileTypeMap = {
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <DialogTitle style={{ width: "800px" }}>
        File Viewer
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {supportedDocs.includes(fileExtension) ? (
          <StyledDocViewer
            documents={[{ uri: fileUrl, fileType: fileTypeMap[fileExtension] }]}
            pluginRenderers={DocViewerRenderers}
            style={{ width: "100%", height: "80vh" }}
          />
        ) : isImage ? (
          <img
            src={fileUrl}
            alt="File"
            style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
          />
        ) : isVideo ? (
          <video
            controls
            style={{ width: "100%", maxHeight: "400px", objectFit: "contain" }}
          >
            <source src={fileUrl} type={`video/${fileExtension}`} />
            Your browser does not support the video tag.
          </video>
        ) : (
          <Box textAlign="center" padding={3}>
            <InsertDriveFileIcon style={{ fontSize: 60, color: "gray" }} />
            <Typography variant="h6" marginTop={2}>
              File Preview Not Available
            </Typography>
            <Button
              variant="outlined"
              color="primary"
              href={fileUrl}
              download
              style={{ marginTop: "10px" }}
            >
              Download File
            </Button>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FileViewerModal;
